<nav class="bg-primary-900">
	<div class="mx-auto max-w-7xl px-2 sm:px-6">
		<div class="relative flex h-16 items-center justify-between">
			<div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
				<!-- Mobile menu button-->
				<button
					type="button"
					class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
					aria-controls="mobile-menu"
					aria-expanded="false"
					(click)="toggleNavbar()">
					<span class="absolute -inset-0.5"></span>
					<span class="sr-only">Open main menu</span>
					<!--
              Icon when menu is closed.
  
              Menu open: "hidden", Menu closed: "block"
            -->
					<svg
						class="block h-6 w-6"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						aria-hidden="true">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
					</svg>
					<!--
              Icon when menu is open.
  
              Menu open: "block", Menu closed: "hidden"
            -->
					<svg
						class="hidden h-6 w-6"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						aria-hidden="true">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
			</div>
			<div
				class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
				<div class="flex flex-shrink-0 items-center logo logo__white">
					activar
				</div>
				<div class="hidden sm:ml-6 sm:block">
					<div class="flex space-x-4"  *showForRole="['AGENT', 'ADMIN', 'SUPERADMIN']">
						<!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
						<a
							href="#"
							class="rounded-md bg-primary-900 px-3 py-2 text-sm font-medium text-white"
							aria-current="page"
							>Inicio</a
						>
						<a
							href="/cotizaciones"
							class="rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
							>Cotizaciones</a
						>
						<a
							href="/polizas"
							class="rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
							>Pólizas</a
						>
						<a 
							href="/usuarios"
							class="rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
							>{{getUsersButtonName()}}</a
						>
						<a
							href="/inspecciones"
							class="rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
							>Inspecciones</a
						>
						<a
							href="/qrs"
							class="rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
							>QRs</a
						>
						
							<a
								href="/administracion"
								class="rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
								*showForRole="['SUPERADMIN']" >Administración</a
						>

						<a
							href="https://soporte.activar.app/es-ar"
							target="_blank"
							class="rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
							>Manuales</a
						>
					</div>
				</div>
			</div>
			<div
				class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
				<button
					type="button"
					class="relative rounded-full text-white hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
					<span class="absolute -inset-1.5"></span>
					<span class="sr-only">View notifications</span>
					<svg
						class="h-6 w-6"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						aria-hidden="true">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
					</svg>
				</button>

				<!-- Profile dropdown -->
				<div class="relative ml-3">
					<div>
						<button
							type="button"
							class="relative flex"
							id="user-menu-button"
							aria-expanded="false"
							aria-haspopup="true"
							(click)="toggleDropdown()">
							<activar-user-avatar
								[firstName]="user()!.firstName"
								[lastName]="user()!.lastName"
								[companyName]="user()!.companyName" />
						</button>
					</div>

					<!--
              Dropdown menu, show/hide based on menu state.
  
              Entering: "transition ease-out duration-100"
                From: "transform opacity-0 scale-95"
                To: "transform opacity-100 scale-100"
              Leaving: "transition ease-in duration-75"
                From: "transform opacity-100 scale-100"
                To: "transform opacity-0 scale-95"
            -->
					<div
						class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dropdown-container"
						[ngClass]="
							isDropdownOpen
								? 'dropdown__open'
								: 'dropdown__leave'
						"
						role="menu"
						aria-orientation="vertical"
						aria-labelledby="user-menu-button"
						tabindex="-1">
						<!-- Active: "bg-gray-100", Not Active: "" -->
						<a
							(click)="goToProfile()"
							(keydown)="goToProfile()"
							class="block px-4 py-2 text-sm text-gray-700"
							role="menuitem"
							tabindex="-1"
							id="user-menu-item-2"
							>Perfil</a
						>
						<a
							(click)="logout()"
							(keydown)="logout()"
							class="block px-4 py-2 text-sm text-gray-700"
							role="menuitem"
							tabindex="-1"
							id="user-menu-item-2"
							>Salir</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Mobile menu, show/hide based on menu state. -->
	<div
		class="sm:hidden"
		id="mobile-menu"
		[ngClass]="isNavbarOpen ? 'dropdown__open' : 'dropdown__leave'">
		<div class="space-y-1 px-2 pb-3 pt-2">
			<!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
			<a
				href="/dashboard"
				class="block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white"
				aria-current="page"
				>Inicio</a
			>
			<a
				href="/cotizaciones"
				class="block rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
				>Cotizaciones</a
			>
			<a
				href="/polizas"
				class="block rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
				>Pólizas</a
			>
			<a
				href="/usuarios"
				class="block rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-blue hover:text-white"
				>Usuarios</a
			>
			<a
				href="/inspecciones"
				class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
				>Inspecciones</a
			>
			<a
				href="/qrs"
				class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
				>QRs</a
			>
			<a
				href="https://soporte.activar.app/es-ar" target="_blank"
				class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
				>Manuales</a
			>
			
				<a
					href="/administracion"
					class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white" *showForRole="['SUPERADMIN']"
					>Administración</a
				>
			
		</div>
	</div>
</nav>
